module.exports = __webpack_public_path__ + "img/09_bohle.df269190.jpeg";